import axios from 'axios';

export const getUrl = () => {
  return 'https://api.pompaprogram.com';
};

export const getUrlBasedOnEnv = () => {
  if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
    return 'https://zgg7z5tys4.execute-api.us-east-2.amazonaws.com/prod';
  }
  return 'https://api-staging.pompaprogram.com';
};

export const getApiKey = () => {
  return 'X53Gi1EC669wQE4SPWjOc8EFADuXHNSCN7laV9Ob';
};

export const createConfigRequest = (path, method, data) => {
  const url = getUrlBasedOnEnv();
  return {
    url: `${url}/${path}`,
    method,
    data,
    headers: {
      'x-api-key': getApiKey(),
      'Content-Type': 'application/json',
    },
  };
};

export const getApiUrl = () => {
  return 'https://api.pompaprogram.com';
};

export const getAvailableReports = (email) => {
  return {
    url: `${getApiUrl()}/available-reports?email=${encodeURIComponent(email)}`,
    method: 'get',
    headers: {
      'x-api-key': getApiKey(),
      'Content-Type': 'application/json',
    },
  };
};

export const downloadNtaiReport = (email, env) => {
  return {
    url: `${getApiUrl()}/download-ntai?email=${encodeURIComponent(
      email
    )}&env=${env}`,
    method: 'get',
    headers: {
      'x-api-key': getApiKey(),
      'Content-Type': 'application/json',
    },
  };
};

// Shared axios instance with timeout and automatic retry on transient failures
const apiClient = axios.create({
  timeout: 30000,
  headers: {
    'x-api-key': getApiKey(),
    'Content-Type': 'application/json',
  },
});

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;
const RETRYABLE_STATUSES = [408, 429, 502, 503, 504];

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config) return Promise.reject(error);

    config.__retryCount = config.__retryCount || 0;

    const isRetryable =
      error.code === 'ERR_NETWORK' ||
      error.code === 'ECONNABORTED' ||
      (error.response && RETRYABLE_STATUSES.includes(error.response.status));

    if (isRetryable && config.__retryCount < MAX_RETRIES) {
      config.__retryCount += 1;
      const delay = RETRY_DELAY * Math.pow(2, config.__retryCount - 1);
      await new Promise((resolve) => setTimeout(resolve, delay));
      return apiClient(config);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
